// ======================================================================
// File Name       : index
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as Messages from '../constants/MessageTemplate';
import * as ValidateUtils from '../utils/ValidateUtils';

export const required = value => (value ? undefined : Messages.W_REQUIRED);

export const alphaNumberic = value =>
  value && !/^[a-zA-Z0-9_]+$/i.test(value) ? Messages.W_VALUE_INVALID : undefined;

export const generalPurposeNumber = value =>
  // sprint_20230403 #2 START
  value && !/^(\d{2}-\d{4}-\d{4}($|(?!-00$)(?!-000$)-\d{2,3}))+$/i.test(value) ? Messages.W_PATTERN_INCORRECT : undefined;
  // sprint_20230403 #2 END

// sprint_20230403 #6 START
export const alphaNumbericHyphen = value =>
  value && !/^[a-zA-Z0-9_-]+$/i.test(value) ? Messages.W_VALUE_INVALID : undefined;
// sprint_20230403 #6 END

// sprint_20230403 #4 START
export const emailAddress = value =>
  value && !ValidateUtils.validEmail(value) ? Messages.W_PATTERN_INCORRECT : undefined;

export const phoneNumber = value =>
  value && !ValidateUtils.validPhoneNumber(value) ? Messages.W_PATTERN_INCORRECT : undefined;
// sprint_20230403 #4 END

// sprint_20230731_tma START
export const saleCd = value =>
value && !ValidateUtils.validSaleCd(value) ? Messages.W_VALUE_INVALID : undefined;
// sprint_20230731_tma END
